"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("@shared/views/BaseView");
var models_1 = require("@shared/models");
var DeckFilterMenu_vue_1 = __importDefault(require("./DeckFilterMenu.vue"));
var DeckItem_vue_1 = __importDefault(require("./DeckItem.vue"));
var DeckFilters_vue_1 = __importDefault(require("./DeckFilters.vue"));
var DeckBrowse = /** @class */ (function (_super) {
    __extends(DeckBrowse, _super);
    function DeckBrowse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = new models_1.PagedResult();
        _this.searchRequest = new models_1.DeckSearchRequest();
        return _this;
    }
    /** Fires when this component is mounted */
    DeckBrowse.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setTitle('Skate Lurker - Decks');
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeckBrowse.prototype.refresh = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __awaiter(this, void 0, void 0, function () {
            var _o, _p, _q, _r, _s, _t, _u, err_1;
            return __generator(this, function (_v) {
                switch (_v.label) {
                    case 0:
                        _v.trys.push([0, 14, 15, 16]);
                        this.searchRequest.clear();
                        // RESTORE THE SEARCH REQUEST FROM THE CURRENT URL
                        this.searchRequest = new models_1.DeckSearchRequest(this.$route.query);
                        if (!this.searchRequest.sortBy) {
                            this.searchRequest.sortBy = 'year';
                            this.searchRequest.sortDirection = 'asc';
                        }
                        if (this.searchRequest.pageSize > 240) {
                            this.searchRequest.pageSize = 240;
                        }
                        if (!(((_b = (_a = this.searchRequest) === null || _a === void 0 ? void 0 : _a.companyIds) === null || _b === void 0 ? void 0 : _b.length) && (!this.searchRequest.companies || this.searchRequest.companyIds.length !== this.searchRequest.companies.length))) return [3 /*break*/, 2];
                        _o = this.searchRequest;
                        return [4 /*yield*/, this.$api.companyService.getMultiple(this.searchRequest.companyIds)];
                    case 1:
                        _o.companies = _v.sent();
                        _v.label = 2;
                    case 2:
                        if (!(((_d = (_c = this.searchRequest) === null || _c === void 0 ? void 0 : _c.artistIds) === null || _d === void 0 ? void 0 : _d.length) && (!this.searchRequest.artists || this.searchRequest.artistIds.length !== this.searchRequest.artists.length))) return [3 /*break*/, 4];
                        _p = this.searchRequest;
                        return [4 /*yield*/, this.$api.artistService.getMultiple(this.searchRequest.artistIds)];
                    case 3:
                        _p.artists = _v.sent();
                        _v.label = 4;
                    case 4:
                        if (!(((_f = (_e = this.searchRequest) === null || _e === void 0 ? void 0 : _e.proIds) === null || _f === void 0 ? void 0 : _f.length) && (!this.searchRequest.pros || this.searchRequest.proIds.length !== this.searchRequest.pros.length))) return [3 /*break*/, 6];
                        _q = this.searchRequest;
                        return [4 /*yield*/, this.$api.proService.getMultiple(this.searchRequest.proIds)];
                    case 5:
                        _q.pros = _v.sent();
                        _v.label = 6;
                    case 6:
                        if (!(((_h = (_g = this.searchRequest) === null || _g === void 0 ? void 0 : _g.seriesIds) === null || _h === void 0 ? void 0 : _h.length) && (!this.searchRequest.series || this.searchRequest.seriesIds.length !== this.searchRequest.series.length))) return [3 /*break*/, 8];
                        _r = this.searchRequest;
                        return [4 /*yield*/, this.$api.seriesService.getMultiple(this.searchRequest.seriesIds)];
                    case 7:
                        _r.series = _v.sent();
                        _v.label = 8;
                    case 8:
                        if (!(((_k = (_j = this.searchRequest) === null || _j === void 0 ? void 0 : _j.categoryIds) === null || _k === void 0 ? void 0 : _k.length) && (!this.searchRequest.categories || this.searchRequest.categoryIds.length !== this.searchRequest.categories.length))) return [3 /*break*/, 10];
                        _s = this.searchRequest;
                        return [4 /*yield*/, this.$api.categoryService.getMultiple(this.searchRequest.categoryIds)];
                    case 9:
                        _s.categories = _v.sent();
                        _v.label = 10;
                    case 10:
                        if (!(((_m = (_l = this.searchRequest) === null || _l === void 0 ? void 0 : _l.technologyIds) === null || _m === void 0 ? void 0 : _m.length) && (!this.searchRequest.technologies || this.searchRequest.technologyIds.length !== this.searchRequest.technologies.length))) return [3 /*break*/, 12];
                        _t = this.searchRequest;
                        return [4 /*yield*/, this.$api.technologyService.getMultiple(this.searchRequest.technologyIds)];
                    case 11:
                        _t.technologies = _v.sent();
                        _v.label = 12;
                    case 12:
                        if (!this.searchRequest.pageSize) {
                            this.searchRequest.pageSize = 60;
                        }
                        if (!this.searchRequest.sortDirection) {
                            this.searchRequest.sortDirection = 'desc';
                        }
                        this.loading = true;
                        _u = this;
                        return [4 /*yield*/, this.$api.deckService.search(this.searchRequest)];
                    case 13:
                        _u.list = _v.sent();
                        return [3 /*break*/, 16];
                    case 14:
                        err_1 = _v.sent();
                        this.errorMessage = 'An error occurred while getting the results';
                        this.errorHandler.handle(err_1, this.errorMessage);
                        return [3 /*break*/, 16];
                    case 15:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the page is changed */
    DeckBrowse.prototype.pageChanged = function (page) {
        this.scroll.scrollToTop();
        this.searchRequest.pageIndex = (page - 1);
        this.searchRequest.companyIds = this.searchRequest.companies.map(function (x) { return x.id; });
        this.searchRequest.technologyIds = this.searchRequest.technologies.map(function (x) { return x.id; });
        this.searchRequest.artistIds = this.searchRequest.artists.map(function (x) { return x.id; });
        this.searchRequest.proIds = this.searchRequest.pros.map(function (x) { return x.id; });
        this.searchRequest.categoryIds = this.searchRequest.categories.map(function (x) { return parseInt(x.id.toString(), null); });
        // STORE SELECTED FILTERS IN LOCAL STORAGE
        this.storage.store('deck-filter', this.searchRequest);
        this.$router.push({ name: 'deck-list', query: this.searchRequest.collapse() }).catch(function () { });
    };
    __decorate([
        vue_property_decorator_1.Watch('$route', { immediate: false, deep: true })
    ], DeckBrowse.prototype, "refresh", null);
    DeckBrowse = __decorate([
        vue_property_decorator_1.Component({
            components: {
                DeckFilterMenu: DeckFilterMenu_vue_1.default,
                DeckItem: DeckItem_vue_1.default,
                DeckFilters: DeckFilters_vue_1.default,
            },
        })
    ], DeckBrowse);
    return DeckBrowse;
}(BaseView_1.BaseView));
exports.default = DeckBrowse;
